/**
 * Configurações específicas para o cliente "Happy"
 */
const settings: ClientSettings = {
  name: "Happy",
  in100authority: "o Banco Pine S/A",
  downloadTermText: "A Happy",
  theme: {
    token: {
      colorPrimary: "#004be3ff",
    },
  },
  assets: {
    logo: "/logo.png",
    favicon: "/favicon.png",
    card: "/card.png",
    refinCard: "/refin-card.png",
    consignedCard: "/consigned-card.png",
    bankLogo: "/bank-logo.png",
    bank_name: "Banco",
  },
  cardExclusiveTheme: {
    name: "Amigoz",
    theme: {
      token: {
        colorPrimary: "#00A2E0",
      },
    },
    assets: {
      logo: "/card-logo.png",
      favicon: "/favicon-card-exclusive.png",
      bankLogo: "/pine-logo.png",
    },
  },
};

export default settings;
